// 在request.js中引入axios
import Vue from 'vue'
import Router from '../src/router'
import axios from 'axios'
import QS from 'qs' // 用来序列化post类型的数据
import { Message } from 'element-ui'
// 访问域名
let baseURL = ''
if (window.location.href.indexOf('beta') != -1) {
    baseURL = 'https://spotlight-beta.istarshine.com/'
} else if (window.location.href.indexOf('spotlight.istarshine.com') != -1) {
    baseURL = 'https://spotlight.istarshine.com/'
} else {
    baseURL = 'https://spotlight-alpha.istarshine.com/'
}
const instance1 = axios.create({
    baseURL,
    timeout: 15000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})
const instance2 = axios.create({
    baseURL,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
})
//H5 报告预览项目部署的域名
window.sessionStorage.setItem('baseURL', baseURL)

// 请求拦截器
instance1.interceptors.request.use(
    config => {
        return config
    },
    error => {
        return Promise.reject(error)
    }
)

// 响应拦截器
instance1.interceptors.response.use(
    response => {
        if (typeof response.data.body == 'string') {
            return response.data
        } else {
            if (response.data.header.status == 200) {
                return response.data.body
            } else if (response.data.header.status == 400 && process.env.NODE_ENV != 'development') {
                //本地开发环境，跳过登录校验
                if (Router.currentRoute.name == 'index') {
                    return Promise.reject(response.data)
                }
                //  跳转到登录页
                Router.push({ path: '/login' })
            } else if (response.data.header.status == 401) {
                let errMsg = '当前用户没有权限' // (response.data.header && response.data.header.msg) ||
                Message.error(errMsg)
                return response
            } else {
                return Promise.reject(response.data)
            }
        }
    },
    // 服务器状态码不是200的情况
    error => {
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        return Promise.reject(error.response)
    }
)

/**
 * 本地调试时，处理权限验证问题;
 * 添加调试参数 debug=true&aid=4
 * @param params
 * @returns {*}
 */
function handleParams(params) {
    if (process.env.NODE_ENV == 'development') {
        if (Object.prototype.toString.call(params) === '[object Object]') {
            params = params || {}
            params.debug = true
            params.debugMobile = 15210351071
        } else {
            if (params == undefined || params.toString().indexOf('?') == -1) {
                params = params + '?debug=true&debugMobile=15210351071'
            } else {
                params = params + '&debug=true&debugMobile=15210351071'
            }
        }
    }
    return params
}

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .get(url, {
                params: handleParams(params)
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function get2(url, params) {
    return new Promise((resolve, reject) => {
        instance2
            .get(url, {
                params: handleParams(params)
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export function getForGpt(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .get(url, {
                timeout: 60000,
                params: handleParams(params)
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
export function getDelay(url, params, timeout = 15000, cancelToken = null) {
    return new Promise((resolve, reject) => {
        instance1
            .get(url, {
                timeout: timeout,
                params: handleParams(params),
                cancelToken: cancelToken
            })
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export function getEncode(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .get(url, {
                params: params instanceof URLSearchParams ? params : handleParams(params)
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * getId方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function getId(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .get(url + handleParams(params))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
/**
 * postId方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postId(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .post(url + handleParams(params))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .post(url, QS.stringify(handleParams(params)))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function postDelay(url, params, timeout = 15000, cancelToken = null) {
    return new Promise((resolve, reject) => {
        instance1
            .post(url, QS.stringify(handleParams(params)), {
                timeout: timeout,
                cancelToken: cancelToken
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function post2(url, params) {
    return new Promise((resolve, reject) => {
        instance2
            .post(url, QS.stringify(handleParams(params)))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function postForGpt(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .create({
                baseURL,
                timeout: 60000,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .post(url, QS.stringify(handleParams(params)))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * postBody，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postBody(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .post(url, { data: handleParams(params) })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .put(url, QS.stringify(handleParams(params)))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * putBody方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function putBody(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .put(url, { data: handleParams(params) })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * del方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function del(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .delete(url, { params: handleParams(params) })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * del方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function delDirect(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .delete(url + handleParams(params))
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

/**
 * delBody方法，对应deleteBody请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function delBody(url, params) {
    return new Promise((resolve, reject) => {
        instance1
            .delete(url, { data: handleParams(params) })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export function fileGet(url, params, config) {
    return instance2.get(url, Object.assign({params: handleParams(params)}, config))
}



//////////////////
// WEBPACK FOOTER
// ./request/request.js
// module id = OaZ/
// module chunks = 53